import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { MobileNavDetails } from "../../../layout/MobileNavbar";
import Container from "../../../layout/Container";
import Navbar from "../../../layout/Navbar";
import { BackTracker, UrlTracker } from "../../../layout/CustomComponents";
import SavingsForm from "./SavingsForm";
import SavingsSummary from "./SavingsSummary";
import { useDispatch, useSelector } from "react-redux";
import {
	createRegularSavings,
	fetchCurrentInterest,
} from "../../../redux/lease/leaseServices";

const LeaseRegularSavingsCreate = () => {
	const dispatch = useDispatch();
	const [activeTab, setActiveTab] = useState(1);
	const navigate = useNavigate();

	const { regularSavingsForm, payment } = useSelector((state) => state.lease);

	useEffect(() => {
		dispatch(fetchCurrentInterest("Base Interest rate (Savings) leasing"));
	}, []);

	const data = {
		...regularSavingsForm,
		paymentMode: payment?.method,
		savingsType: "regular",
		purpose: regularSavingsForm?.purpose || "General",
	};

	return (
		<>
			<MobileNavDetails text="savings" />
			<Helmet>
				<title>Fortcore - Regular Savings</title>
			</Helmet>
			<Container>
				<>
					<Navbar text="leasing" />
					<div className="sm:pt-9 md:pt-10 "></div>
					<BackTracker text="regular savings" onNavigate={() => navigate(-1)} />
					<div className="flex gap-1.5">
						<UrlTracker
							text="leasing"
							onNavigate={() => navigate("/leasing")}
						/>
						<UrlTracker text="regular savings" isCurrentUrl />
					</div>
					<div className="sm:mt-6"></div>
					{activeTab === 1 && <SavingsForm setActiveTab={setActiveTab} />}
					{activeTab === 2 && (
						<SavingsSummary
							setActiveTab={setActiveTab}
							savingsUrl={"/leasing/regular-savings"}
							onSubmitSavings={() => dispatch(createRegularSavings(data))}
						/>
					)}
				</>
			</Container>
		</>
	);
};

export default LeaseRegularSavingsCreate;
